import { CritereService } from 'src/app/services/critere/critere.service';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import {Component,Input,OnChanges,SimpleChanges, Output, EventEmitter, ViewContainerRef} from '@angular/core';
import { AtcdPanelService } from 'src/app/services/atcd-panel/atcd-panel.service';
import { AtcdPanelSection, AtcdPanelCategoryKey } from './atcd-side-panel.model';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { LoginService } from 'src/app/services/login/login.service';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
import * as moment from 'moment';
import { AntecedentPerso } from 'src/app/utils/interfaces/new/antecedent-perso.interface';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PatientService } from 'src/app/services/patient/patient.service';

@Component({
  selector: 'frg-atcd-side-panel',
  templateUrl: './atcd-side-panel.fragment.html',
  styleUrls: ['./atcd-side-panel.fragment.scss']
})
export class AtcdSidePanelFragment implements OnChanges {
  @Input() patientId: string;
  @Input() currentProfil: Profil;
  @Input() connectedDropListIds:string[];
  @Output() availableDropZoneIdsChange = new EventEmitter<string[]>();
  @Output() availableAtcdSourceIdsChange = new EventEmitter<string[]>();

  public collapsed = true;
  public isLoading = false;
  public sections: AtcdPanelSection[] = [];
  public activeDropSectionKey: string | null = null;
  private currentSourceId: string | null = null;
  private loadedPatientId: string | null = null;
  private destinatairesCabinet: Destinataire[];
  private sources:any[] = [];
  private typeObservation: Array<Referentiel> = [];
  private antecedentCritereId: string | null = null;

  constructor(
    private atcdPanelService: AtcdPanelService,
    private _cabinet: CabinetService,
    private _login: LoginService,
    private _strUtilsSrv: StringUtilsService,
    private _ref: ReferentielService,
    private _modal: ModalService,
    private _view: ViewContainerRef,
    private _patient: PatientService,
    private _critere: CritereService,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.patientId && !changes.patientId.firstChange) {
      if (changes.patientId.currentValue !== changes.patientId.previousValue) {
        this.sections = [];
        this.loadedPatientId = null;
      }
    }
  }

  public async togglePanel(): Promise<void> {
    this.collapsed = !this.collapsed;

    if(this.currentProfil){
      this.currentSourceId = this.currentProfil.id;
    }

    if (!this.collapsed) {
      await this.ensureDataLoaded();
    }
    this.emitAvailableDropZoneIds();
    this.emitAvailableAtcdSourceIds();

  }

  public toggleSection(section: AtcdPanelSection): void {
    section.expanded = !section.expanded;
    this.emitAvailableDropZoneIds();
    this.emitAvailableAtcdSourceIds();
  }

  public get visibleSections(): AtcdPanelSection[] {
    return this.sections.filter(section => section.enabled || section.items.length > 0);
  }

  private async ensureDataLoaded(): Promise<void> {
    if (!this.patientId) {
      return;
    }

    if (this.loadedPatientId === this.patientId && this.sections.length > 0) {
      return;
    }

    this.isLoading = true;

    if(!this.currentSourceId) {
      const getCurrentUser = this._login.getCurrentUser();
      const localAuth = {
        utilisateur: getCurrentUser,
      }
      const currentUser = this._login.findOneAuth(localAuth);
      if (currentUser) {
        this.currentSourceId = currentUser.profil.id;
      }
    }

    await this.resolveAntecedentCritere();

    try {
      if (!this.typeObservation || this.typeObservation.length === 0) {
        this.typeObservation = await this._ref.findRefListTableHypermed('RefProblemCode');
      }

      this.sections = await this.atcdPanelService.getAtcd(this.patientId);
      this.loadedPatientId = this.patientId;
    } finally {
      this.isLoading = false;
    }
    this.emitAvailableAtcdSourceIds();
    this.emitAvailableDropZoneIds();
  }

  public async onDrop(event: CdkDragDrop<any>, section: AtcdPanelSection): Promise<void> {
    if (!section.droppable) {
      return;
    }
    this.activeDropSectionKey = null;
    const dragData = event.item.data;
    if (!dragData?.ligne) {
      return;
    }

    await this.openSimpleAtcdModal(section.key, {
      antecedent: dragData?.ligne?.nomCritere || '',
      commentaire: this.buildCommentFromDrag(dragData)
    });

  }

  private emitAvailableDropZoneIds(): void {
    if (this.collapsed) {
      this.availableDropZoneIdsChange.emit([]);
      return;
    }

    const ids = this.visibleSections
      .filter(section => section.droppable)
      .map(section => `atcd-drop-${section.key}`);

    this.availableDropZoneIdsChange.emit(ids);
  }

  private emitAvailableAtcdSourceIds(): void {
    if (this.collapsed) {
      this.availableAtcdSourceIdsChange.emit([]);
      return;
    }

    const ids = this.visibleSections
      .filter(section => section.expanded && section.items && section.items.length > 0)
      .map(section => `atcd-items-${section.key}`);

    this.availableAtcdSourceIdsChange.emit(ids);
  }

  public getSectionClasses(section: AtcdPanelSection): string[] {
    return [
      `atcd-section--${section.key}`,
      section.droppable ? 'atcd-section--droppable' : '',
      this.activeDropSectionKey === section.key ? 'atcd-section--drop-active' : ''
    ].filter(Boolean);
  }

  public onDropEntered(section: AtcdPanelSection): void {
    if (!section.droppable) {
      return;
    }

    this.activeDropSectionKey = section.key;
  }

  public onDropExited(section: AtcdPanelSection): void {
    if (this.activeDropSectionKey === section.key) {
      this.activeDropSectionKey = null;
    }
  }

  private getSimpleTypeConfig(sectionKey: AtcdPanelCategoryKey): {
      idTypeAntecedent: string;
      title: string;
    } | null {
    switch (sectionKey) {
      case 'uncoded':
        return {
          idTypeAntecedent: 'f3d42e80-5ce6-4dee-9034-8f56e6790dd2',
          title: 'Antécédent non codé'
        };

      case 'obstetrical':
        return {
          idTypeAntecedent: '520d9063-68ce-4156-937d-301dd1647926',
          title: 'Antécédent obstétrical'
        };

      case 'allergy-uncoded':
        return {
          idTypeAntecedent: 'b4441376-371f-4c16-a18e-dcd69788a4c1',
          title: 'Antécédent allergie non codée'
        };

      default:
        return null;
    }
  }

  private buildCommentFromDrag(dragData: any): string {
    const parts: string[] = [];

    if (dragData?.displayValue) {
      parts.push(`${dragData.displayValue}`);
    } else if (
      dragData?.value !== null &&
      dragData?.value !== undefined &&
      dragData?.value !== ''
    ) {
      parts.push(`${dragData.value}`);
    }

    if (dragData?.ligne?.descriptionCritere) {
      parts.push(dragData.ligne.descriptionCritere);
    }

    return parts.join(' | ');
  }

  private async openSimpleAtcdModal( sectionKey: AtcdPanelCategoryKey,
    preset?: {
      antecedent?: string;
      commentaire?: string;
    }): Promise<void> {
    const typeConfig = this.getSimpleTypeConfig(sectionKey);
    if (!typeConfig) {
      return;
    }

    if(this.sources.length === 0){
      const destinatairesCabinet = await this._cabinet.findCurrentCabinetDestinataire();
      this.sources = [];
      for (let destinataire of destinatairesCabinet) {
        if (!destinataire.disabled) {
          this.sources.push({ id: destinataire.id, libelle: destinataire.nom.toLocaleUpperCase() + ' ' + this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom) });
        }
      }
    }


    const currentSource = this.sources.find(source => source.id === this.currentSourceId);
    const atcd:AntecedentPerso = {
      idPatient: this.patientId,
      source: currentSource?.id,
      dateAntecedent:moment().format('DD/MM/YYYY'),
      idTypeAntecedent: typeConfig.idTypeAntecedent,
      antecedent: undefined,
      commentaire: undefined,
      code: undefined,
      disabled: false,
      typeObservationCode: this.typeObservation.find(item => item.libelle === 'Problème') || undefined,
      endDate: undefined,
    };

    let maxDate = new Date;
    let idTypeAtcd:string;

    const prefilledAntecedent = preset?.antecedent || '';
    const prefilledComment = preset?.commentaire || '';

    const inputs = [
      { id: 'dateAntecedent', label: 'Date de début', placeholder: '', type: 'date', variable: 'dateAntecedent', dateMax:maxDate, required:true },
      { id: 'antecedent', label: 'Antécédent', placeholder: 'Description de l\'antécédent', type: 'text', variable: 'antecedent', required: true },
      { id: 'commentaire', label: 'Commentaire', placeholder: 'Commentaire supplémentaire', type: 'text', variable: 'commentaire' },
      { id: 'source', label: 'Source', placeholder: 'Source', type: 'ngSelect',selectOptions: this.sources , variable: 'source', required: true},
    ];

    const modalForm = this._modal.openModalAddEdit(typeConfig.title, this._view, {inputs}, true,
      {
        dateAntecedent: atcd.dateAntecedent? moment(atcd.dateAntecedent, 'DD/MM/YYYY').format('YYYY-MM-DD') : undefined,
        idTypeAntecedent:  typeConfig.idTypeAntecedent || undefined,
        typeObservationCode: atcd.typeObservationCode? atcd.typeObservationCode?.id : undefined,
        antecedent: prefilledAntecedent,
        commentaire: prefilledComment,
        source: atcd.source
      },
      undefined,
      { updateButtonText: 'Enregistrer' }
    );

    modalForm.instance.skipValueChangeFunc = 0;

      const sub = this._modal.closeEmitter.subscribe(async rtdV => {
        const newAtcd = rtdV?.object;
        modalForm.destroy();
        sub.unsubscribe();

        if (rtdV?.loadingModal) {
          rtdV.loadingModal.destroy();
        }
        if (!newAtcd) {
          return;
        }

        atcd.antecedent = newAtcd.antecedent?.libelle || newAtcd.antecedent || prefilledAntecedent;
        atcd.commentaire = newAtcd.commentaire || '';
        atcd.source = newAtcd.source || atcd.source;
        atcd.dateAntecedent = this.formatDate(newAtcd.dateAntecedent)|| this.formatDate(atcd.dateAntecedent)
        atcd.endDate = '';
        atcd.code = undefined;

        await this._patient.updatePatientAntecedentsPerso(this.patientId, [atcd]);

        this.atcdPanelService.clear(this.patientId);
        this.sections = [];
        this.loadedPatientId = null;
        await this.ensureDataLoaded();


      });
    }

  private formatDate(inputDate: string | { _d: unknown }, format = 'YYYY-MM-DD'): string | undefined {
    if (!inputDate) return undefined;

    if (typeof inputDate === 'object' && '_d' in inputDate && inputDate._d instanceof Date) {
      return moment(inputDate._d).format(format);
    }

    if (typeof inputDate === 'string') {
      const trimmed = inputDate.trim();
      const formatsToTry = [
        'DD/MM/YYYY',
        'YYYY-MM-DD',
        'DD-MM-YYYY',
        'YYYY/MM/DD',
      ];

      for (const fmt of formatsToTry) {
        const date = moment(trimmed, fmt, true);
        if (date.isValid() && date.format(fmt) === trimmed) {
          return date.format(format);
        }
      }

      console.warn(`formatDate: date invalide détectée "${inputDate}"`);
      return undefined;
    }

    return undefined;
  }

  public buildAtcdDragData(section: AtcdPanelSection, item: any): any {
    const value = [
      section?.label && item?.label ? `${section.label} : ${item.label}` : null,
      item?.comment || null,
      item?.dateLabel || null
    ].filter(Boolean).join(', ')
    return {
      source: 'atcd',
      sectionKey: section.key,
      item,
      suggestedCritere: {
        idCritere: this.antecedentCritereId,
        displayName: 'Antécédent',
        type: 'alphanumerique'
      },
      value: value
    };
  }

  private async resolveAntecedentCritere(): Promise<void> {
  if (this.antecedentCritereId) {
    return; //cache déjà rempli
  }

  try {
    const res = await this._critere.resolveCriteres([
      { displayName: 'Antécédent', type: 'alphanumerique' }
    ]);

    const crit = res?.[0];

    if (!crit?.id) {
      throw new Error('Critère Antécédent non résolu');
    }

    this.antecedentCritereId = crit.id;

  } catch (error) {
    console.error('resolveAntecedentCritere error', error);
  }
}
}
